const pluralRules = new Intl.PluralRules('en-US');

export function pluralizeUnit(count: number, unit: string): string {
  return pluralRules.select(count) === 'one' ? unit : `${unit}s`;
}

export default function getAmountLabel(count: number, unit: string) {
  return `${count.toLocaleString('en-US')} ${pluralizeUnit(count, unit)}`;
}
